module.exports = new __parcel__URL__("ConfluenceIcon.3b027e05.svg").toString();